import { MidAutumnCampaignApiResponse } from '../../../schema/campaigns';
import { CakeApiBase } from '../../CakeApiBase';

export class MidAutumnCampaignApi extends CakeApiBase {
  async getMidAutumnData() {
    return this.requestManager.get<MidAutumnCampaignApiResponse>('/campaigns/mid-autumn');
  }
}
